export default __webpack_public_path__ + "static/media/rocket_anim_83.ddcc0fbe.png";